import React, { useState } from 'react';
// import JSONPretty from 'react-json-pretty';

import Grid from '@material-ui/core/Grid'
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Typography from '@material-ui/core/Typography'
import makeFilters from '../../../app/common/RegexFilters';
import SearchInput from './SearchInput';



const CaseSearchContent = ({ courtCases = [], referrals = [], onSelect }) => {

    const [filters, setFilters] = useState(makeFilters(undefined));

    return (
        <Grid container direction="column" spacing={1}>
            <Grid item>
                <Typography variant="h6" color="initial">Search by Client, Case Number, or Booking Reference</Typography>
            </Grid>
            <Grid item>
                <SearchInput onChange={setFilters} />
            </Grid>
            <Grid item>
                <List disablePadding>
                    {
                        courtCases
                            .map(courtCase => {
                                // add the booking reference so we can filter on it
                                const { bookingReference = '' } = referrals.find(({ courtCaseId = '' }) => courtCase.id === courtCaseId) || {};
                                return { ...courtCase, bookingReference }
                            })
                            .filter(({ serviceUserName = '', courtCaseNumber = '', bookingReference = '' }) => {
                                return (Boolean(serviceUserName) || Boolean(courtCaseNumber) || Boolean(bookingReference))
                                    && filters.every(rx => rx.test(`${serviceUserName} ${courtCaseNumber} ${bookingReference}`))
                            })
                            .sort((a, b) => b.ts - a.ts)
                            .map(item => {
                                const { id, serviceUserName = '', courtCaseNumber = '', bookingReference = '', court: { name: courtName = '' } = {} } = item;
                                return (
                                    <ListItem key={id} button onClick={() => onSelect(item)} disableGutters>
                                        <ListItemText primary={serviceUserName} secondary={`Court Case ${courtCaseNumber} ${courtName} Booking Ref ${bookingReference}`} />
                                    </ListItem>
                                );
                            })
                            .slice(0, 20)
                    }
                </List>
            </Grid>
        </Grid>
    );
};

export default CaseSearchContent;